document.addEventListener("DOMContentLoaded", function () {
    const input = document.querySelector('[js-nutritional-input]');
    const nutritionalItems = document.querySelectorAll('[data-nutritional-value]');
    const openButtons = document.querySelectorAll('[js-open-model]'); // updated
    const closeButton = document.querySelector('[js-close-popup-icon]');
    const popupOverlay = document.querySelector('[js-article-content-overlay]');
    const popupBox = document.querySelector('[js-article-content-popup]');

    if (!input) return;

    const EPS_FACTOR = 1e-9;

    function parseQuantityText(text) {
        if (!text) return null;
        const s = text.trim().replace(/\s+/g, ' ');
        if (!s) return null;

        const unicodeRational = {
            '½': [1, 2],
            '¼': [1, 4],
            '¾': [3, 4],
            '⅓': [1, 3],
            '⅔': [2, 3],
            '⅛': [1, 8]
        };
        for (const [sym, pair] of Object.entries(unicodeRational)) {
            if (s.startsWith(sym)) {
                const [rn, rd] = pair;
                const unit = s.slice(sym.length).trim();
                return { value: rn / rd, unit, rationalNum: rn, rationalDen: rd };
            }
        }

        const fracMatch = s.match(/^(\d+)\s*\/\s*(\d+)\s*(.*)$/);
        if (fracMatch) {
            const rn = parseInt(fracMatch[1], 10);
            const rd = parseInt(fracMatch[2], 10);
            if (!isNaN(rn) && !isNaN(rd) && rd > 0) {
                const unit = (fracMatch[3] || '').trim();
                return { value: rn / rd, unit, rationalNum: rn, rationalDen: rd };
            }
        }

        const slashUnitMatch = s.match(/^(\d+)\s*\/\s*([A-Za-zäöüÄÖÜß°].*)$/);
        if (slashUnitMatch) {
            const v = parseFloat(slashUnitMatch[1]);
            if (!isNaN(v)) {
                return { value: v, unit: slashUnitMatch[2].trim() };
            }
        }

        const decMatch = s.match(/^([\d.,]+)\s*(.*)$/);
        if (decMatch) {
            const v = parseFloat(decMatch[1].replace(',', '.'));
            if (!isNaN(v)) {
                let unit = (decMatch[2] || '').trim();
                unit = unit.replace(/^\/+(?=[A-Za-zäöüÄÖÜß°])/, '').trim();
                return { value: v, unit };
            }
        }

        return null;
    }

    /** Recipe default: quantities in the meta are for this many portions. */
    const referenceServings = Math.max(1, parseFloat(input.value) || 1);

    let lastValidValue = parseFloat(input.value);
    if (isNaN(lastValidValue) || lastValidValue < 1) {
        lastValidValue = 1;
    }

    nutritionalItems.forEach((item) => {
        item.dataset.originalDisplay = item.textContent.trim();
        const fullText = item.dataset.originalDisplay;
        const parsed = parseQuantityText(fullText);
        if (!parsed) return;

        item.dataset.baseValue = String(parsed.value);
        item.dataset.unit = parsed.unit || '';
        if (parsed.rationalNum != null && parsed.rationalDen != null) {
            item.dataset.rationalNum = String(parsed.rationalNum);
            item.dataset.rationalDen = String(parsed.rationalDen);
        } else {
            delete item.dataset.rationalNum;
            delete item.dataset.rationalDen;
        }
    });

    function baseNumeric(item) {
        const rNum = item.dataset.rationalNum;
        const rDen = item.dataset.rationalDen;
        if (rNum && rDen) {
            const n = parseInt(rNum, 10);
            const d = parseInt(rDen, 10);
            if (d > 0) return n / d;
        }
        const base = parseFloat(item.dataset.baseValue);
        return isNaN(base) ? NaN : base;
    }

    function scaledAmountForServings(item, servings) {
        const base = baseNumeric(item);
        if (!Number.isFinite(base)) return NaN;
        const factor = servings / referenceServings;
        return base * factor;
    }

    /** Whole numbers stay integers; otherwise show decimals (e.g. 1.5), not rounded integers. */
    function formatScaledQuantity(raw) {
        if (!Number.isFinite(raw)) return '';
        const r = Math.round(raw);
        if (Math.abs(raw - r) < 1e-6) {
            return String(r);
        }
        return String(Number(raw.toFixed(2)));
    }

    function updateNutritionalValues(servings) {
        const factor = servings / referenceServings;
        nutritionalItems.forEach((item) => {
            if (item.dataset.fixed === "true") return;

            if (Math.abs(factor - 1) < EPS_FACTOR) {
                item.textContent = item.dataset.originalDisplay || '';
                return;
            }

            const unit = item.dataset.unit || '';
            const raw = scaledAmountForServings(item, servings);
            if (!Number.isFinite(raw)) return;

            const qty = formatScaledQuantity(raw);
            item.textContent = unit ? `${qty} ${unit}` : qty;
        });
    }

    input.addEventListener('input', () => {
        const currentValue = parseFloat(input.value);
        if (!isNaN(currentValue) && currentValue >= 1 && currentValue <= 100) {
            lastValidValue = currentValue;
            updateNutritionalValues(currentValue);
        } else if (input.value !== '') {
            input.value = lastValidValue;
        }
    });

    document.addEventListener('click', function (e) {
        const button = e.target.closest('[js-ingredient-button]');
        if (button) {
            let currentValue = parseFloat(input.value) || 1;
            if (currentValue < 100) {
                currentValue += 1;
                input.value = currentValue;
                lastValidValue = currentValue;
                updateNutritionalValues(currentValue);
            }
        }
    });

    updateNutritionalValues(lastValidValue);

    if (popupOverlay && popupBox) {
        openButtons.forEach((openButton) => {
            openButton.addEventListener('click', function () {
                popupOverlay.classList.add('is-open');
                popupBox.classList.add('is-open');
            });
        });
    }

    if (closeButton && popupOverlay && popupBox) {
        closeButton.addEventListener('click', function () {
            popupOverlay.classList.remove('is-open');
            popupBox.classList.remove('is-open');
        });

        popupOverlay.addEventListener('click', function () {
            popupOverlay.classList.remove('is-open');
            popupBox.classList.remove('is-open');
        });
    }
});

document.addEventListener('click', function (e) {
    const shareBtn = e.target.closest('[js-ingredient-share-button]');
    if (shareBtn) {
        const url = window.location.href;
        navigator.clipboard.writeText(url).then(() => {
            const originalText = shareBtn.textContent;
            shareBtn.textContent = 'kopiert!';
            shareBtn.classList.add('copied');
            setTimeout(() => {
                shareBtn.textContent = originalText;
                shareBtn.classList.remove('copied');
            }, 2000);
        });
    }
});

const printBtn = document.querySelector("[js-print-btn]");
printBtn?.addEventListener("click", function (event) {
    event.preventDefault();
    window.print();
});
